module.exports = "../images/boat-3.jpg?v=1fba192";